import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';

import { ContextMenuActionType, IContextMenuGridAction } from '../../../prisma-xs/models/prisma-xs.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-prisma-xs-second-menu-context',
    templateUrl: './second-menu-context.component.html',
    styleUrls: ['./second-menu-context.component.scss', '../../scss/context-menu.scss'],
    standalone: false
})
export class SecondMenuContextComponent {
  @ViewChild('secondUserMenu', { static: true }) secondUserMenu: TemplateRef<any>;

  @Input() contextMenuActionType: any;
  @Input() articleToCopy: boolean;

  @Output() contextMenuActionData = new EventEmitter<IContextMenuGridAction>();

  contextMenuAction(actionType: ContextMenuActionType, ref?: string) {
    this.contextMenuActionData.emit({ type: actionType, uuid: ref });
  }
}
